
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class WorkflowMapGrid extends SiteEntityGrid<WorkflowMapRow, any> {
        protected getColumnsKey() { return 'Workflow.WorkflowMap'; }
        protected getDialogType() { return WorkflowMapDialog; }
        protected getIdProperty() { return WorkflowMapRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowMapRow.localTextPrefix; }
        protected getService() { return WorkflowMapService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }

        protected getButtons() {
            var buttons = super.getButtons();

            var addButton = Q.tryFirst(buttons, x => x.cssClass == 'add-button');
            if (addButton)
                addButton.title = 'New';

            buttons.splice(1, 0, {
                title: 'Batch Assign',
                cssClass: 'batch-assignment-button',
                icon: 'fa-plus-square text-orange',
                onClick: () => {
                    var dlg = new WorkflowBatchAssignmentDialog();
                    dlg.element.on('dialogclose', () => this.refresh());
                    dlg.dialogOpen();
                }
            });

            buttons.splice(3, 0, {
                cssClass: 'delete-selected-button',
                icon: 'fa-trash-o text-red',
                hint: 'Delete Selected',
                onClick: () => {
                    var keys = this.rowSelection.getSelectedAsInt32();
                    if (!keys.length) {
                        Q.notifyWarning("Please select some mappings to delete!");
                        return;
                    }

                    Q.confirm("Delete selected " + keys.length + " mappings?", () => {

                        WorkflowMapService.BatchDelete({
                            MapIdList: keys
                        },
                            response => {
                                Q.notifySuccess("Selected " + keys.length + " mapping(s) are deleted.");
                                this.rowSelection.clear();
                                this.refresh();
                            });
                    });
                }
            });

            return buttons;
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            var el = $('<input type="hidden" placeholder="--assign workflow to selected--" />').appendTo(this.toolbar.element);
            var editor = new FormatLookupEditor(el, {
                lookupKey: WorkflowRow.lookupKey,
                allowClear: true
            });
            editor.changeSelect2(e => {
                var workflowCode = editor.value;
                if (!workflowCode)
                    return;

                var keys = this.rowSelection.getSelectedAsInt32();
                if (!keys.length) {
                    Q.notifyWarning("Please select some mappings to update workflow code!");
                    return;
                }

                Q.confirm("Update selected " + keys.length + " mappings to workflow: '" + workflowCode + "'?", () => {

                    WorkflowMapService.BatchUpdate({
                        MapIdList: keys,
                        WorkflowCode: workflowCode
                    },
                        response => {
                            Q.notifySuccess("Workflow for selected " + keys.length + " mapping(s) are updated.");
                            this.rowSelection.clear();
                            this.refresh();
                        });
                });

                editor.value = null;
            });

        }
    }
}